"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _isArrayLikeObject = _interopRequireDefault(require("lodash/isArrayLikeObject"));

var _isString = _interopRequireDefault(require("lodash/isString"));

var _react = _interopRequireWildcard(require("react"));

var _reactDom = require("react-dom");

var _reactRedux = require("react-redux");

var _ssrWindow = require("ssr-window");

var _dom = _interopRequireDefault(require("@spothero/utils/dom"));

var Portal =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(Portal, _PureComponent);

  function Portal(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Portal);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Portal).call(this, props));
    var className = props.className,
        appendTo = props.appendTo;
    _this._EL = _ssrWindow.document.createElement('div');
    _this._ROOT = (0, _isString.default)(appendTo) ? _dom.default.el(appendTo) : appendTo;

    if ((0, _isArrayLikeObject.default)(_this._ROOT)) {
      _this._ROOT = _this._ROOT[0];
    }

    if (className) {
      _dom.default.addClass(_this._EL, className);
    }

    return _this;
  }

  (0, _createClass2.default)(Portal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._ROOT.appendChild(this._EL);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._ROOT.removeChild(this._EL);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          store = _this$props.store,
          children = _this$props.children;

      if (store) {
        return (0, _reactDom.createPortal)(_react.default.createElement(_reactRedux.Provider, {
          store: store
        }, children), this._EL);
      } else {
        return (0, _reactDom.createPortal)(children, this._EL);
      }
    }
  }]);
  return Portal;
}(_react.PureComponent);

exports.default = Portal;
(0, _defineProperty2.default)(Portal, "defaultProps", {
  appendTo: _ssrWindow.document.body
});